import WixSDK from 'shared/utils/wix-sdk';
import { getCompId } from 'shared/utils/comp-id';


export const REFRESH_EVENT = 'refreshOnLoginEvents';


export function storeForReload(data) {
  WixSDK.PubSub.publish(REFRESH_EVENT, {
    uid: WixSDK.Utils.getInstanceValue('uid'),
    origCompId: getCompId(),
    stored: {
      ...data,
    },
  }, true);
}



// WEBPACK FOOTER //
// ./src/widget/utils/reload.js